export const environment = {
  production: true,
  bankIdUrl: 'https://bankid-test.sealthedeal.se/service',
  apiUrl: 'https://foto-backend-test.sealthedeal.se/api',
  service: 'fotografera'
}
